'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _Record2;

import { Record } from 'immutable';
import I18n from 'I18n';
import { ProcessingConsentTypes, LegalConsentKeys, LegalConsentOptions, EditableLegalConsentKeys, SettingsKeys } from '../constants/LegalConsent';
import isEmpty from 'hs-lodash/isEmpty';
import isEqual from 'hs-lodash/isEqual';
import findIndex from 'hs-lodash/findIndex';

var keyedText = function keyedText(key, options) {
  return I18n.text("gdpr." + key, options);
};

var DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS = 'LEGITIMATE_INTEREST_PQL';
var DEFAULT_OPTIONS = {
  checkboxOptions: []
};
export function getEditableLegalConsentKeysForLegalConsentType(legalConsentType) {
  switch (legalConsentType) {
    case LegalConsentOptions.IMPLICIT_CONSENT:
      return [EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, EditableLegalConsentKeys.PRIVACY_POLICY_TEXT, EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT];

    case LegalConsentOptions.SEPERATE_CONSENT:
      return [EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT, EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];

    case LegalConsentOptions.LEGITIMATE_INTEREST:
      return [EditableLegalConsentKeys.SUBSCRIPTION_TYPES, EditableLegalConsentKeys.LAWFUL_BASIS, EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];

    default:
      return [];
  }
}

var LegalConsent = /*#__PURE__*/function (_Record) {
  _inherits(LegalConsent, _Record);

  function LegalConsent() {
    _classCallCheck(this, LegalConsent);

    return _possibleConstructorReturn(this, _getPrototypeOf(LegalConsent).apply(this, arguments));
  }

  _createClass(LegalConsent, [{
    key: "addOrUpdateCommunicationCheckbox",
    value: function addOrUpdateCommunicationCheckbox(newCheckbox) {
      var oldCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var currentCheckboxes = this.get(LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);
      var updatedCheckboxes = currentCheckboxes;

      if (!isEmpty(oldCheckbox)) {
        var updateIndex = findIndex(currentCheckboxes, {
          communicationTypeId: oldCheckbox.communicationTypeId
        });
        updatedCheckboxes = currentCheckboxes.map(function (value, index) {
          if (index === updateIndex) {
            return newCheckbox;
          }

          return value;
        });
      } else {
        updatedCheckboxes = currentCheckboxes.concat([newCheckbox]);
      }

      return this.set(LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, updatedCheckboxes);
    }
  }, {
    key: "removeCheckbox",
    value: function removeCheckbox(removedCheckbox) {
      var currentCheckboxes = this.get(LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);
      return this.set(LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, currentCheckboxes.filter(function (_ref) {
        var communicationTypeId = _ref.communicationTypeId;
        return !isEqual(removedCheckbox.communicationTypeId, communicationTypeId);
      }));
    }
  }, {
    key: "getLegalConsentType",
    value: function getLegalConsentType() {
      var isLegitimateInterest = this.get(LegalConsentKeys.IS_LEGITIMATE_INTEREST);
      var processingConsentType = this.get(LegalConsentKeys.PROCESSING_CONSENT_TYPE);

      if (!isLegitimateInterest && processingConsentType === ProcessingConsentTypes.IMPLICIT) {
        return LegalConsentOptions.IMPLICIT_CONSENT;
      } else if (!isLegitimateInterest && processingConsentType === ProcessingConsentTypes.REQUIRED_CHECKBOX) {
        return LegalConsentOptions.SEPERATE_CONSENT;
      } else if (isLegitimateInterest) {
        return LegalConsentOptions.LEGITIMATE_INTEREST;
      }

      return LegalConsentOptions.NONE;
    } // Overite method to prevent arrays being cast to immutables

  }, {
    key: "merge",
    value: function merge() {
      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LegalConsent();
      var updatedRecord = Object.values(EditableLegalConsentKeys || {}).reduce(function (memo, key) {
        if (isEmpty(record.get(key)) || isEqual(key, LegalConsentKeys.PRIVACY_POLICY_TEXT) || isEqual(key, LegalConsentKeys.PROCESSING_CONSENT_TEXT)) {
          return memo;
        }

        return memo.set(key, record.get(key));
      }, this);
      return updatedRecord;
    }
  }], [{
    key: "createLegalConsentFromOption",
    value: function createLegalConsentFromOption() {
      var _options;

      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LegalConsentOptions.IMPLICIT_CONSENT;
      var otherOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
      var checkboxOptions = otherOptions.checkboxOptions,
          companyName = otherOptions.domain;

      if (option === LegalConsentOptions.NONE) {
        return null;
      }

      var proccessingConsentType = option === LegalConsentOptions.SEPERATE_CONSENT ? ProcessingConsentTypes.REQUIRED_CHECKBOX : ProcessingConsentTypes.IMPLICIT;
      var isLegitimateInterest = option === LegalConsentOptions.LEGITIMATE_INTEREST;
      var processingConsentTextKey = option === LegalConsentOptions.IMPLICIT_CONSENT ? 'implicitProcessingConsentText' : 'explicitProcessingConsentText';
      var privacyPolicyKey = isLegitimateInterest ? 'legitimateInterestPrivacyPolicyText' : 'privacyPolicyText';
      var options = (_options = {}, _defineProperty(_options, LegalConsentKeys.IS_LEGITIMATE_INTEREST, isLegitimateInterest), _defineProperty(_options, LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, otherOptions[SettingsKeys.COMMUNICATION_CONSENT_TEXT] || keyedText('communicationConsentText', {
        companyName: companyName
      })), _defineProperty(_options, LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, checkboxOptions), _defineProperty(_options, LegalConsentKeys.PROCESSING_CONSENT_TYPE, proccessingConsentType), _defineProperty(_options, LegalConsentKeys.PROCESSING_CONSENT_TEXT, otherOptions[processingConsentTextKey] || keyedText(processingConsentTextKey, {
        companyName: companyName
      })), _defineProperty(_options, LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, otherOptions[SettingsKeys.EXPLICIT_PROCESSING_CONSENT_CHECKBOX_LABEL] || keyedText('explicitProcessingConsentCheckboxLabel', {
        companyName: companyName
      })), _defineProperty(_options, LegalConsentKeys.PRIVACY_POLICY_TEXT, otherOptions[privacyPolicyKey] || keyedText(privacyPolicyKey, {
        companyName: companyName
      })), _options);

      if (isLegitimateInterest && !isEmpty(checkboxOptions)) {
        options[LegalConsentKeys.SUBSCRIPTION_TYPES] = [checkboxOptions[0].communicationTypeId];
      }

      return new LegalConsent(options);
    }
  }]);

  return LegalConsent;
}(Record((_Record2 = {}, _defineProperty(_Record2, LegalConsentKeys.IS_LEGITIMATE_INTEREST, false), _defineProperty(_Record2, LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, ''), _defineProperty(_Record2, LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, []), _defineProperty(_Record2, LegalConsentKeys.PROCESSING_CONSENT_TYPE, ProcessingConsentTypes.IMPLICIT), _defineProperty(_Record2, LegalConsentKeys.PROCESSING_CONSENT_TEXT, ''), _defineProperty(_Record2, LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, ''), _defineProperty(_Record2, LegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, ''), _defineProperty(_Record2, LegalConsentKeys.PRIVACY_POLICY_TEXT, ''), _defineProperty(_Record2, LegalConsentKeys.SUBSCRIPTION_TYPES, []), _defineProperty(_Record2, LegalConsentKeys.LAWFUL_BASIS, DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS), _Record2)));

export { LegalConsent as default };